import { RouteItem } from '@eastcoal/router/types/route'

import {
  TRADITION_AUCTION_CREATE_PAGE_PATH,
  TRADITION_AUCTION_LIST_PAGE_PATH
} from './constants/path'
import { TRADITION_AUCTION_LIST_PAGE_UUID } from './constants/uuid'

export const traditionAuctionRoute: RouteItem = {
  title: '竞拍',
  hideChildrenInMenu: true,
  uuid: TRADITION_AUCTION_LIST_PAGE_UUID,
  children: [
    {
      title: '竞拍列表',
      path: TRADITION_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增竞拍',
      path: TRADITION_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
